// extracted by mini-css-extract-plugin
export var Avatar = "style-module--Avatar--fda4c";
export var Contact = "style-module--Contact--1c6f8";
export var ContactDetails = "style-module--ContactDetails--70da4";
export var Description = "style-module--Description--87aea";
export var Name = "style-module--Name--8248f";
export var Profile = "style-module--Profile--3b0af";